import { useState, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { DialogContent, DialogActions } from '@mui/material';
import { Checkbox } from 'rsuite';
import { useMembers } from '@app/api/members/useMembers';
import { ThemeButton } from '@shared/ui/buttons';
import Note from '@shared/ui/messages/Note';
import { FormGroup } from '@shared/ui/forms/display';
import { MemberRoleView } from '@shared/ui/forms/inputs';
import { getTotalCards } from '@utils/helpers';

export default function DeleteMemberDialog({
  close,
  data,
  setTitleIcon,
  setClassNames,
  setImage,
}) {
  const { deleteMember } = useMembers();
  const { t } = useTranslation();
  const [isConfirm, setIsConfirm] = useState(false);
  const hasCards = getTotalCards(data) > 0;

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: 'onChange',
    defaultValues: { terms_accept: false },
  });

  async function onSubmit() {
    try {
      await deleteMember({ user_id: data.id });
      close();
    } catch (error) {
      console.error(error);
    }
  }

  useLayoutEffect(() => {
    if (isConfirm) {
      setClassNames('');
      setImage('');
      setTitleIcon('warning');
    } else {
      setClassNames('top-img-style');
      setImage('delete');
      setTitleIcon('');
    }
  }, [isConfirm]);

  return (
    <>
      <DialogContent>
        <div className="form">
          <p>{t('are_sure_member_delete')}</p>
          <MemberRoleView member={data} />
          {!isConfirm && (
            <Note
              marginTop
              type="warning"
              title={t('important')}
              content={t('member_delete_note')}
            >
              {hasCards && (
                <FormGroup error={errors.terms_accept}>
                  <Controller
                    control={control}
                    name="terms_accept"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Checkbox
                        onChange={(val, checked) => field.onChange(checked)}
                        checked={field.value}
                      >
                        {t('i_agree_to_delete_member')}
                      </Checkbox>
                    )}
                  />
                </FormGroup>
              )}
            </Note>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton
            startIcon="delete"
            loading={isSubmitting}
            disabled={hasCards && !watch('terms_accept')}
            onClick={() =>
              isConfirm ? handleSubmit(onSubmit)() : setIsConfirm(true)
            }
          >
            {t('yes_delete')}
          </ThemeButton>
          <ThemeButton
            onClick={() => (isConfirm ? setIsConfirm(false) : close())}
            appearance="secondary"
          >
            {t('no_cancel')}
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}
